(function() {
  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function parsePlanInterval(plan) {
    if (!plan || !plan.name) {
      return {
        count: 1,
        unit: 'month'
      };
    }

    var match = String(plan.name).match(/(\d+)\s*(day|days|week|weeks|month|months|year|years)/i);
    var count = match ? parseInt(match[1], 10) : 1;
    var unit = match ? match[2].toLowerCase() : 'month';

    if (unit.slice(-1) === 's') {
      unit = unit.slice(0, -1);
    }

    return {
      count: count || 1,
      unit: unit
    };
  }

  function formatCadenceLabel(prefix, plan) {
    var interval = parsePlanInterval(plan);
    var normalizedPrefix = prefix || 'Ships';

    if ((interval.unit === 'month' && interval.count === 1) || (interval.unit === 'day' && interval.count === 30)) {
      return normalizedPrefix + ' monthly';
    }

    if (interval.unit === 'week' && interval.count === 1) {
      return normalizedPrefix + ' weekly';
    }

    return normalizedPrefix + ' every ' + interval.count + ' ' + interval.unit + (interval.count === 1 ? '' : 's');
  }

  function getCurrentVariant(form) {
    var currentVariantJson = form && form.querySelector('[data-current-variant-json]');
    if (currentVariantJson) {
      try {
        return JSON.parse(currentVariantJson.textContent);
      } catch (error) {
        return null;
      }
    }

    var variantsJson = form && form.querySelector('[data-variant-json]');
    var variantIdInput = form && form.querySelector('[name="id"]');

    if (variantsJson && variantIdInput) {
      try {
        var variants = JSON.parse(variantsJson.textContent);
        return variants.find(function(variant) {
          return String(variant.id) === String(variantIdInput.value);
        }) || variants[0] || null;
      } catch (error) {
        return null;
      }
    }

    return null;
  }

  function getVariantList(form) {
    var variantsJson = form && form.querySelector('[data-variant-json]');

    if (!variantsJson) {
      return [];
    }

    try {
      return JSON.parse(variantsJson.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  function getSelectedVariantFromInputs(scope, variants) {
    if (!scope || !Array.isArray(variants) || !variants.length) {
      return null;
    }

    var selectedOptions = {};

    scope.querySelectorAll('[data-variant-input]:checked').forEach(function(input) {
      if (input.dataset.index) {
        selectedOptions[input.dataset.index] = input.value;
      }
    });

    return variants.find(function(variant) {
      return ['option1', 'option2', 'option3'].every(function(optionKey) {
        return !selectedOptions[optionKey] || String(variant[optionKey]) === String(selectedOptions[optionKey]);
      });
    }) || null;
  }

  function normalizeSellingPlanId(value) {
    if (value === null || typeof value === 'undefined') {
      return '';
    }

    var match = String(value).match(/(\d+)(?!.*\d)/);
    return match ? match[1] : '';
  }

  function getSellingPlanInput(form) {
    if (!form) {
      return null;
    }

    var existingInput = form.querySelector('input[name="selling_plan"]');
    if (existingInput) {
      return existingInput;
    }

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'selling_plan';
    form.appendChild(input);
    return input;
  }

  function variantSupportsSellingPlan(variant, sellingPlanId) {
    var normalizedPlanId = normalizeSellingPlanId(sellingPlanId);

    if (!variant || !normalizedPlanId || !Array.isArray(variant.selling_plan_allocations)) {
      return false;
    }

    return variant.selling_plan_allocations.some(function(allocation) {
      return normalizeSellingPlanId(allocation && allocation.selling_plan_id) === normalizedPlanId;
    });
  }

  function getSelectedAllocation(variant, sellingPlanId) {
    if (!variant || !Array.isArray(variant.selling_plan_allocations) || !variant.selling_plan_allocations.length) {
      return null;
    }

    var normalizedPlanId = normalizeSellingPlanId(sellingPlanId);

    if (normalizedPlanId) {
      var matchedAllocation = variant.selling_plan_allocations.find(function(allocation) {
        return normalizeSellingPlanId(allocation && allocation.selling_plan_id) === normalizedPlanId;
      });

      if (matchedAllocation) {
        return matchedAllocation;
      }
    }

    return variant.selling_plan_allocations[0] || null;
  }

  function getSubscriptionUnitPrice(variant, sellingPlanId) {
    var allocation = getSelectedAllocation(variant, sellingPlanId);

    if (!allocation) {
      return variant && variant.price ? variant.price : 0;
    }

    return allocation.per_delivery_price || (variant && variant.price ? variant.price : 0);
  }

  function variantIsPods(variant) {
    if (!variant) {
      return false;
    }

    return ['option1', 'option2', 'option3'].some(function(optionKey) {
      var optionValue = variant[optionKey];
      return typeof optionValue === 'string' && optionValue.toLowerCase().indexOf('pod') !== -1;
    });
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.initialized === 'true') {
      return;
    }

    gallery.dataset.initialized = 'true';

    var image = gallery.querySelector('[data-airdrop-gallery-image]');
    if (!image) {
      return;
    }

    var imageEntries = {};
    gallery.querySelectorAll('[data-airdrop-gallery-entry]').forEach(function(entry) {
      imageEntries[String(entry.dataset.variantId)] = {
        src: entry.dataset.src || '',
        srcset: entry.dataset.srcset || '',
        width: entry.dataset.width || '',
        height: entry.dataset.height || '',
        alt: entry.dataset.alt || ''
      };
    });

    gallery._syncVariantImage = function(variantId) {
      var nextImage = imageEntries[String(variantId)] || imageEntries.default;
      if (!nextImage || !nextImage.src) {
        return;
      }

      image.src = nextImage.src;

      if (nextImage.srcset) {
        image.srcset = nextImage.srcset;
      } else {
        image.removeAttribute('srcset');
      }

      if (nextImage.width) {
        image.setAttribute('width', nextImage.width);
      }

      if (nextImage.height) {
        image.setAttribute('height', nextImage.height);
      }

      image.alt = nextImage.alt || '';
    };

    if (imageEntries.default) {
      gallery._syncVariantImage('default');
    }
  }

  function initProduct(root) {
    if (!root || root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';

    var section = root.closest('.month-club-airdrop');
    var form = section && section.querySelector('.product-single__form');

    if (!section || !form) {
      return;
    }

    var addToCartButton = form.querySelector('[data-add-to-cart]');
    var addToCartText = form.querySelector('[data-add-to-cart-text]');
    var displayedPrice = section.querySelector('[data-airdrop-price]');
    var cadenceText = section.querySelector('[data-airdrop-cadence]');
    var includedCopy = section.querySelector('.month-club-airdrop__included-copy');
    var includedCopyGroundTemplate = section.querySelector('[data-airdrop-included-copy-template="ground"]');
    var includedCopyPodsTemplate = section.querySelector('[data-airdrop-included-copy-template="pods"]');
    var gallery = section.querySelector('[data-airdrop-gallery]');
    var variantSelect = form.querySelector('[name="id"]');
    var variants = getVariantList(form);
    var sellingPlanInput = getSellingPlanInput(form);
    var ctaLabel = root.dataset.ctaLabel || 'Join the Airdrop';
    var cadencePrefix = root.dataset.cadencePrefix || 'Ships';
    var forcedSellingPlanId = normalizeSellingPlanId(root.dataset.sellingPlanId);
    var currentVariant = getCurrentVariant(form);

    function syncSellingPlanInput(sellingPlanId) {
      if (!sellingPlanInput) {
        return;
      }

      var nextValue = normalizeSellingPlanId(sellingPlanId);
      if (sellingPlanInput.value !== nextValue) {
        sellingPlanInput.value = nextValue;
        sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function syncButton() {
      if (!addToCartText || !addToCartButton || addToCartButton.disabled) {
        return;
      }

      addToCartText.innerHTML = '<span class="month-club-airdrop__button-label">' + ctaLabel + '</span>';
    }

    function syncUi() {
      currentVariant = getCurrentVariant(form) || currentVariant;
      if (!currentVariant) {
        return;
      }

      var activeAllocation = getSelectedAllocation(currentVariant, forcedSellingPlanId);
      var activePrice = activeAllocation
        ? getSubscriptionUnitPrice(currentVariant, forcedSellingPlanId)
        : (currentVariant.price || 0);

      if (displayedPrice) {
        displayedPrice.textContent = formatMoney(activePrice);
      }

      if (cadenceText) {
        cadenceText.textContent = formatCadenceLabel(cadencePrefix, activeAllocation && activeAllocation.selling_plan);
      }

      if (includedCopy) {
        if (variantIsPods(currentVariant) && includedCopyPodsTemplate) {
          includedCopy.innerHTML = includedCopyPodsTemplate.innerHTML;
        } else if (includedCopyGroundTemplate) {
          includedCopy.innerHTML = includedCopyGroundTemplate.innerHTML;
        }
      }

      if (gallery && typeof gallery._syncVariantImage === 'function') {
        gallery._syncVariantImage(currentVariant.id);
      }

      syncButton();
    }

    function ensureSellingPlanSelected() {
      if (!currentVariant) {
        return;
      }

      if (!Array.isArray(currentVariant.selling_plan_allocations) || !currentVariant.selling_plan_allocations.length) {
        syncSellingPlanInput('');
        return;
      }

      if (variantSupportsSellingPlan(currentVariant, forcedSellingPlanId)) {
        syncSellingPlanInput(forcedSellingPlanId);
        return;
      }

      syncSellingPlanInput(currentVariant.selling_plan_allocations[0].selling_plan_id);
    }

    function syncVariantInputSelection() {
      var selectedVariant = getSelectedVariantFromInputs(root, variants);

      if (!selectedVariant) {
        return;
      }

      currentVariant = selectedVariant;

      if (variantSelect && String(variantSelect.value) !== String(selectedVariant.id)) {
        variantSelect.value = selectedVariant.id;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      section.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: { variant: selectedVariant },
          bubbles: true
        })
      );
    }

    section.addEventListener('variantChange', function(event) {
      currentVariant = event.detail && event.detail.variant ? event.detail.variant : currentVariant;
      window.setTimeout(function() {
        ensureSellingPlanSelected();
        syncUi();
      }, 0);
    });

    ensureSellingPlanSelected();
    syncUi();

    root.querySelectorAll('[data-variant-input]').forEach(function(input) {
      input.addEventListener('change', function() {
        syncVariantInputSelection();
      });
    });

    form.addEventListener('submit', function() {
      ensureSellingPlanSelected();
    });
  }

  function initAccordions(scope) {
    if (!scope || scope.dataset.accordionInitialized === 'true') {
      return;
    }

    scope.dataset.accordionInitialized = 'true';

    var triggers = Array.prototype.slice.call(scope.querySelectorAll('[data-airdrop-accordion-trigger]'));
    if (!triggers.length) {
      return;
    }

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        var controlsId = trigger.getAttribute('aria-controls');
        var panel = controlsId ? document.getElementById(controlsId) : null;

        trigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

        if (panel) {
          panel.hidden = isExpanded;
        }
      });
    });
  }

  function initAll(context) {
    var scope = context || document;

    scope.querySelectorAll('[data-airdrop-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-airdrop-product]').forEach(initProduct);
    scope.querySelectorAll('[data-airdrop-accordions]').forEach(initAccordions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
